/*
 * ModelStore
 * A wrapper over Backbone.Models that handles
 * loading / caching and sharing of models
 * throughout the apps components
 */

import Store from './store';

export default Store;
export { default as Helper } from './helper.js';
